<template>
  <ItemsQuestion
    v-if="parkOffersAssociation"
    ref="child"
    v-on:answerUpdated="onAnswerUpdated"
    :question="question"
    :answer="answer"
    :isDisabled="isDisabled"
  ></ItemsQuestion>
</template>

<script>
  import ParkPrograms from '@/services/park_programs'
  import ItemsQuestion from './ItemsQuestion'

  export default {
    name: 'AssociationProgramItemsQuestion',
    components: { ItemsQuestion },
    props: ['question', 'answer', 'quizAnswers', 'isDisabled'],
    methods: {
      isValid () {
        if (!this.parkOffersAssociation) {
          return true
        }
        return this.$refs.child.isValid()
      },
      onAnswerUpdated (answer) {
        this.$emit('answerUpdated', answer)
      }
    },
    computed: {
      parkOffersAssociation () {
        return ParkPrograms.has(ParkPrograms.ASSOCIATION, this.quizAnswers)
      }
    },
    watch: {
      parkOffersAssociation: {
        immediate: true,
        handler () {
          if (!this.parkOffersAssociation) {
            this.$emit('answerUpdated', {...this.answer, value: null})
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AssociationProgramItemsQuestion.vue?7fef73ce